module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-brands-400.woff2?167c3d4fd786a2d0ad49bf37cfac2579";